import React from "react";

import { useFormContext, useFormState } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ErrorMessage, RequiredMark } from "@components/inputs/shared";
import classNames from "classnames";

import { TextareaFieldProps } from "./types";

const TextareaField = (props: TextareaFieldProps) => {
	const { t } = useTranslation();

	const {
		label,
		name,
		className,
		errorMessage,
		type = "text",
		cols,
		rows,
		required = false,
		placeholder,
		asterisksClass,
		...rest
	} = props;

	const { register } = useFormContext();
	const { errors } = useFormState();
	let error = errors?.name;

	const field = register(name, {
		required: {
			value: required,
			message: errorMessage || "COMMON.REQUIRED_FIELD",
		},
	});

	const textAreaClass = classNames("input input--med input--textarea", {
		"input-validation-error": error != undefined,
	});

	return (
		<div className={className ? className : "col col-sml-12 form__field"}>
			<label htmlFor={name} className="label">
				{t(label)}
				<RequiredMark
					required={required}
					asterisksClass={asterisksClass}
				/>
			</label>
			<ErrorMessage name={name} />
			<textarea
				className={textAreaClass}
				placeholder={t(placeholder || "")}
				{...rest}
				{...field}
			/>
		</div>
	);
};
export default TextareaField;
